import {Injectable} from '@angular/core';
import * as mapboxgl from 'mapbox-gl';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  mapbox = mapboxgl;
  style = `mapbox://styles/mapbox/streets-v11`;

  constructor() {
    this.mapbox.accessToken = 'pk.eyJ1IjoiamF2aWVybWYiLCJhIjoiUFZvSk5qRSJ9.VW5dRmokGm3gRcc_5Afs2g';
  }

  buildMap(zoom: number, latitude: number, longitude: number, container?: string, controls: boolean = true, projection: any = {name: 'mercator'}): mapboxgl.Map {
    const map = new mapboxgl.Map({
      container: container ?? 'map',
      style: this.style,
      zoom,
      projection: projection,
      center: [longitude, latitude]
    });
    map.on('style.load', () => {
      map.setFog({}); // Set the default atmosphere style
    });
    if (controls) {
      map.addControl(new mapboxgl.NavigationControl());
      map.addControl(new mapboxgl.FullscreenControl());
    }
    this.buildResizeObserver(map, container ?? 'map');
    return map;
  }

  private buildResizeObserver(map: mapboxgl.Map, containerId: string): void {
    let resizeTimeout: any;

    const container: HTMLElement = document.getElementById(containerId);
    if (!container) {
      return;
    }

    const observer: ResizeObserver = new ResizeObserver(([entry]) => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const containerExists: boolean = document.body.contains(entry.target);

        if (!containerExists || !map || !map.getContainer) {
          observer.unobserve(entry.target);
          return;
        }

        try {
          map.resize();
        } catch (e) {
          observer.unobserve(entry.target);
        }
      }, 50);
    });

    observer.observe(container);
  }


  buildStaticPulsingDot(map: mapboxgl.Map, latitude, longitude): mapboxgl.Marker {
    const parent = document.createElement('div');
    parent.className = 'pulse-box';
    const child = document.createElement('div');
    child.className = 'pulse-css';
    parent.append(child);

    return new mapboxgl.Marker(parent)
      .setLngLat([longitude, latitude])
      .addTo(map);
  }

  buildRoadMap(map: mapboxgl.Map, mapMeasures: any[]): void {
    map.on('load', () => {
      map.addSource('route', {
        type: 'geojson',
        data: {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: mapMeasures
          }
        }
      });
      map.addLayer({
        id: 'route',
        type: 'line',
        source: 'route',
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': '#316a8a',
          'line-width': 4
        }
      });
    });
  }
}
